import { Coordinates } from '../../RegularMapWithDirections/interfaces'
import { ArrivalPoints } from '../interfaces'
import { TRANSFER_APPOINTMENT_WAYS } from './constants'

interface CalculateArrivalPointsProps {
  transferWay: TRANSFER_APPOINTMENT_WAYS
  clientDirections: Coordinates
  hospitalDirections: Coordinates
}

export const calculateArrivalPoints = ({
  transferWay,
  clientDirections,
  hospitalDirections,
}: CalculateArrivalPointsProps): ArrivalPoints => {
  if (transferWay === TRANSFER_APPOINTMENT_WAYS.ONEWAY) {
    return {
      startPoint: clientDirections,
      destinationPoint: hospitalDirections,
    }
  } else {
    return {
      startPoint: hospitalDirections,
      destinationPoint: clientDirections,
    }
  }
}
